@if (isReportSending) {
  <div class="wrapper center"
    >
    <div class="inner">
      <mat-spinner> </mat-spinner>
    </div>
  </div>
}

<!-- Start Fishing Report-->
<div class="container report-container">

  <div class="container"
    style="padding-top: 20px;">
    <div class="row"
      align="center">
      @if (currPage <= numPages && reportStatus != 'complete') {
        <h6 i18n>
          <small class="text-muted">
            Page {{currPage}} of {{numPages}}
          </small>
        </h6>
      }
      @if (currPage > numPages) {
        <h6 i18n>
          <small class="text-muted">
            Lost/Recovered Gear Report
          </small>
        </h6>
      }
    </div>

    @if (reportStatus != 'complete') {
      <div class="row" align="center">
        <div class="col" style="display: flex; justify-content: space-between;">
          <mat-icon></mat-icon>
          @if (currPage <= numPages) {
            <mat-spinner
              mode="determinate"
              [diameter]="50"
              [strokeWidth]="6"
            [value]="spinnerProgress"></mat-spinner>
          }
          @if (currPage > numPages) {
            <mat-icon style="color: #3ebfb9">
              check_circle_outline
            </mat-icon>
          }
          <button mat-mini-fab matTooltip="Delete Report" style="background-color: #005d87;" (click)="deleteReport()">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>

  <form [formGroup]="gearForm">


    @if (currPage === 1) {
      <div
        class="container details">
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
                    What is the status of the gear?
                </h5>
        </div>
        <div class="row">
          <mat-radio-group aria-label="Select an option" formControlName="gearStatus" (change)="gearStatusChanged($event)" style="display: flex; flex-direction: row; justify-content: space-evenly;">
            <mat-radio-button i18n value="1">No Fishing Gear Lost</mat-radio-button>
            <mat-radio-button i18n value="2">Lost</mat-radio-button>
            <mat-radio-button i18n value="3">Found</mat-radio-button>
            <mat-radio-button i18n value="4">Partially Recovered</mat-radio-button>
            <mat-radio-button i18n value="5">Fully Recovered</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
             What is the declaration date for this form?
           </h5>
        </div>
        <div class="row"
          align="center">
          <div class="col-2"></div>
          <div class="col-8">
            <mat-card class="demo-inline-calendar-card" style="margin-top: 10%">
              <mat-calendar [(selected)]="declarationDate" [maxDate]="todayDate" (selectedChange)="dateChange()"></mat-calendar>
            </mat-card>
          </div>
          <div class="col-2"></div>
        </div>
      </div>
    }


    @if (currPage === 2 && numPages > 2) {
      <div
        class="container details">
        <div class="row" align="center">
          <h5 i18n class="blue-heading-title">
                    When was the gear lost?
                </h5>
        </div>
        <div class="row" align="center">
          <div class="col-2"></div>
          <div class="col-8">
            <mat-card class="demo-inline-calendar-card" style="margin-top: 10%">
              <mat-calendar [(selected)]="gearLostDate" [maxDate]="todayDate" (selectedChange)="dateChange()"></mat-calendar>
            </mat-card>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
    }


    @if (currPage === 3 && numPages > 2 && gearForm.get('gearStatus')?.value != '2') {
      <div class="container details">
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
                    When was the gear recovered?
                </h5>
        </div>
        <div class="row"
          align="center">
          <div class="col-2"></div>
          <div class="col-8">
            <mat-card class="demo-inline-calendar-card" style="margin-top: 10%">
              <mat-calendar [(selected)]="gearRecoveredDate" [maxDate]="todayDate" (selectedChange)="dateChange()"></mat-calendar>
            </mat-card>
          </div>
          <div class="col-2"></div>
        </div>
      </div>
    }

    @if (currPage === numPages-3) {
      <div
        class="container details">
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
                    Gear Details
                </h5>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
                  What is the Gear Type?
                </h6>
          <mat-form-field appearance="fill">
            <mat-label>Gear Type</mat-label>
            <mat-select formControlName="gearType" [compareWith]="compareGearTypes">
              @for (type of gearTypeOptions; track type) {
                <mat-option [value]="type">{{type}}</mat-option>
              }
            </mat-select>
            @if (gearForm.invalid) {
              <mat-error i18n>
                    Required
                  </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
                  What is the description of the lost, found, or recovered gear(s)?
                </h6>
          <mat-form-field appearance="fill">
            <mat-label>Description</mat-label>
            <textarea matInput
              maxlength="150"
              rows="4"
            formControlName="gearDescription"></textarea>
            @if (gearForm.invalid) {
              <mat-error i18n>
                    Required
                  </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
                  How many Gears have been lost, found, or retrieved?
                </h6>
          <mat-form-field appearance="fill">
            <mat-label i18n>Number of Gears</mat-label>
            <input matInput type="number" formControlName="gearNumber">
            @if (gearForm.get('gearNumber')?.hasError('required')) {
              <mat-error i18n>
                    Required
                  </mat-error>
            }
            @if (gearForm.get('gearNumber')?.hasError('max')) {
              <mat-error i18n>
                    Value must be less than or equal to 9999
                  </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
                    Which fishing gear tags have been lost, found or retrieved?
                </h6>
          <small i18n class="text-body-secondary" style="font-style: italic; color:#005d87">Enter a tag and press enter to add it</small>
          <mat-form-field appearance="fill">
            <mat-label i18n>Gear Tags</mat-label>
            <mat-chip-grid #chipGrid aria-label="Enter gear tags" formControlName="gearTags">
              @for (tag of gearForm.get('gearTags')?.value; track tag) {
                <mat-chip-row (removed)="removeTag(tag)">
                  {{tag}}
                  <button matChipRemove aria-label="'remove ' + tag">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
            </mat-chip-grid>
            <input [matChipInputFor]="chipGrid"
              (matChipInputTokenEnd)="addTag($event)" />
              @if (gearForm.invalid) {
                <mat-error i18n>
                    Required
                  </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
                  What License number was being used when the gear was lost?
                </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>Licence Number</mat-label>
              <input matInput maxlength="18" formControlName="licenseNumber">
              @if (gearForm.invalid) {
                <mat-error i18n>
                    Required
                  </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
                What species was being targeted when the gear was lost?
              </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>Targeted Species</mat-label>
              <mat-select formControlName="targetSpecies" [compareWith]="compareSpeciesData">
                @for (species of targetedSpeciesOptions; track species) {
                  <mat-option [value]="species">{{species}}</mat-option>
                }
              </mat-select>
              @if (gearForm.invalid) {
                <mat-error i18n>
                  Required
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      }

      @if (currPage === numPages-2) {
        <div
          class="container details">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
                Specific component details
            </h5>
          </div>
          @if (gearForm.get('gearType')?.value != 'Troller lines' && gearForm.get('gearType')?.value != 'Pot/Trap' && gearForm.get('gearType')?.value != 'Longline') {
            <div class="row">
              <h6 i18n class="blue-label">
                Length of Net
                </h6>
              <mat-form-field appearance="fill">
                <mat-label i18n>Net Length</mat-label>
                <input matInput type="number" formControlName="netLength">
                @if (gearForm.get('netLength')?.hasError('required')) {
                  <mat-error i18n>
                    Required
                  </mat-error>
                }
                @if (gearForm.get('netLength')?.hasError('max')) {
                  <mat-error i18n>
                    Value must be less than or equal to 99999
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
          <div class="row">
            <h6 i18n class="blue-label">
                Length of Rope (meters)
                </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>Rope length</mat-label>
              <input matInput formControlName="ropeLength">
              @if (gearForm.get('ropeLength')?.hasError('required')) {
                <mat-error i18n>
                    Required
                  </mat-error>
              }
              @if (gearForm.get('ropeLength')?.hasError('max')) {
                <mat-error i18n>
                    Value must be less than or equal to 150000
                  </mat-error>
              }
            </mat-form-field>
          </div>
          @if (gearForm.get('gearType')?.value === 'Gillnet' || gearForm.get('gearType')?.value === 'Longline' || gearForm.get('gearType')?.value === 'Pot/Trap' || gearForm.get('gearType')?.value === 'Other') {
            <div class="row" >
              <h6 i18n class="blue-label">
                Number of Buoys
                </h6>
              <mat-form-field appearance="fill">
                <mat-label i18n >Number of Buoys</mat-label>
                <input matInput maxlength="4" formControlName="buoyNumber">
                @if (gearForm.get('buoyNumber')?.hasError('required')) {
                  <mat-error i18n>
                    Required
                  </mat-error>
                }
                @if (gearForm.get('buoyNumber')?.hasError('min')) {
                  <mat-error i18n>
                    Value must be greater than or equal to 0
                  </mat-error>
                }
                @if (gearForm.get('buoyNumber')?.hasError('max')) {
                  <mat-error i18n>
                    Value must be less than or equal to 1500
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
          @if (gearForm.get('buoyNumber')?.value > 0) {
            <div class="row">
              <h6 i18n class="blue-label">
                Buoy Description
                </h6>
              <mat-form-field appearance="fill">
                <mat-label i18n>Buoy Description</mat-label>
                <textarea matInput formControlName="buoyDescription" maxlength="150"></textarea>
                @if (gearForm.invalid) {
                  <mat-error i18n>
                    Required
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        </div>
      }

      @if (currPage === numPages-1 && gearForm.get('gearStatus')?.value != '1') {
        <div class="container details">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
                  Location and Direction details
              </h5>
          </div>
          @if (numPages == 6 && gearForm.get('gearType')?.value != 'Gillnet' && gearForm.get('gearType')?.value != 'Longline' && gearForm.get('gearType')?.value != 'Pot') {
            <div class="row">
              <h6 i18n class="blue-label">
                What direction was the vessel facing when the gear(s) were lost?
              </h6>
              <mat-form-field appearance="fill">
                <mat-label i18n>Vessel direction</mat-label>
                <mat-select formControlName="vesselDirection">
                  @for (value of vesselDirectionOptions; track value) {
                    <mat-option i18n [value]="value">
                    {value, select, North {North} North-Northeast {North-Northeast} Northeast {Northeast} East-Northeast {East-Northeast} East {East} East-Southeast {East-Southeast} Southeast {Southeast} South-Southeast {South-Southeast} South {South} South-Southwest {South-Southwest} Southwest {Southwest} West-Southwest {West-Southwest} West {West} West-Northwest {West-Northwest} Northwest {Northwest} North-Northwest {North-Northwest}}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          <div style="display: flex; justify-content: space-between; align-items: baseline;">
            <h6 i18n class="blue-label">
                  What were the coordinates when the gear was lost/found/recovered?
              </h6>
            <button mat-mini-fab type="button" class="fishing-button-blue" [matTooltip]="'Fill from GPS'" (click)="geolocationMethod.fillCoordinatesFromGps(gearForm.get('latitude')!, gearForm.get('longitude')!)">
              <mat-icon>pin_drop</mat-icon>
            </button>
          </div>
          <div class="row">
            <mat-form-field appearance="fill">
              <mat-label i18n>Latitude</mat-label>
              <input matInput formControlName="latitude" (mousedown)="geolocationMethod.openCoordinateDialog('latitude', gearForm.get('latitude')!)">
              @if (gearForm.get('latitude')?.hasError('object')) {
                <mat-error i18n>
                  Required
                </mat-error>
              }
              @if (gearForm.get('latitude')?.hasError('latitude')) {
                <mat-error i18n>
                  Latitude out of range. Must be no less than 38° 00.00'N and no greater than 72° 00.00'N
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field appearance="fill">
              <mat-label i18n>Longitude</mat-label>
              <input matInput formControlName="longitude" (mousedown)="geolocationMethod.openCoordinateDialog('longitude', gearForm.get('longitude')!)">
              @if (gearForm.get('longitude')?.hasError('object')) {
                <mat-error i18n>
                  Required
                </mat-error>
              }
              @if (gearForm.get('longitude')?.hasError('longitude')) {
                <mat-error i18n>
                  Longitude out of range. Must be no less than 40° 00.00'W and no greater than 148° 00.00'W
                </mat-error>
              }
            </mat-form-field>
          </div>
          @if (numPages == 6) {
            <div class="row">
              <h6 i18n class="blue-label">
                  Which fishery management area was the gear lost in?
                </h6>
              <mat-form-field appearance="fill">
                <mat-label i18n>Fishery area</mat-label>
                <mat-select formControlName="fisheryArea" [compareWith]="compareArea">
                  @for (area of managementAreas; track area) {
                    <mat-option i18n [value]="area">{{area}}</mat-option>
                  }
                </mat-select>
                @if (gearForm.invalid) {
                  <mat-error i18n>
                    Required
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        </div>
      }

      @if (currPage === numPages) {
        <div class="container details">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
                  Do you have any comments to add?
              </h5>
          </div>
          <div class="row">
            <mat-form-field appearance="fill" >
              <mat-label i18n>Comments</mat-label>
              <textarea matInput
                maxlength="2000"
                rows="9"
              formControlName="comments"></textarea>
            </mat-form-field>
          </div>
        </div>
      }
    </form>

    <!-- Summary page -->
    @if (currPage > numPages) {
      <div class="container details">
        @if (reportStatus != 'complete') {
          <div class="row" align="center">
            <h5 i18n class="blue-heading-title">
          Is all information complete and ready to be saved?
          You won't be able to make any changes after saving
        </h5>
          </div>
        }
        <div class="row">
          <h6 i18n class="blue-label">
         <b>Gear Status:</b>
          <small class="blue-label">
            {{gearForm.get('gearStatus')?.value}}
          </small>
          @if (gearForm.get('gearStatus')?.errors?.required) {
<small
                 class="red-label">
            [Required]
        </small>
}
        </h6>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
          <b>Declaration Date:</b> 
            {{ declarationDate | date }}
        </h6>
        </div>
        @if (numPages > 2) {
          <div  class="row">
            <h6 i18n class="blue-label">
          <b>Gear Lost Date:</b> 
            {{ gearLostDate | date }}
        </h6>
          </div>
        }
        @if (numPages > 2 && gearForm.get('gearStatus')?.value != '2') {
          <div class="row">
            <h6 i18n class="blue-label">
          <b>Gear Recovered Date:</b> 
            {{ gearRecoveredDate | date }}
        </h6>
          </div>
        }
        @if (numPages > 2) {
          <div class="row">
            <h6 i18n class="blue-label">
          <b>Gear Type:</b>
          <small class="blue-label">
            {{gearForm.get('gearType')?.value}}
          </small>
          @if (gearForm.get('gearType')?.errors?.required) {
<small
                class="red-label">
            [Required]
          </small>
}
        </h6>
          </div>
        }
        @if (numPages > 2) {
          <div class="row">
            <h6 i18n class="blue-label">
         <b>Gear Description:</b>
          <small class="blue-label">
            {{gearForm.get('gearDescription')?.value}}
          </small>
          @if (gearForm.get('gearDescription')?.errors?.required) {
<small
                 class="red-label">
            [Required]
        </small>
}
        </h6>
          </div>
        }
        @if (numPages > 2) {
          <div class="row">
            <h6 i18n class="blue-label">
          <b>Number of Gears lost/found/retrieved:</b>
          <small class="blue-label">
            {{gearForm.get('gearNumber')?.value}}
          </small>
          @if (gearForm.get('gearNumber')?.errors?.required) {
<small
                  class="red-label">
            [Required]
          </small>
}
        </h6>
          </div>
        }
        @if (numPages > 2) {
          <div class="row">
            <h6 i18n class="blue-label">
          <b>Lost, Found, or Retrieved Gear Tags:</b>
          <small class="blue-label">
            {{ gearForm.get('gearTags')?.value }}
          </small>
          @if (gearForm.get('gearTags')?.errors?.required) {
<small
                  class="red-label">
            [Required]
          </small>
}
        </h6>
          </div>
        }
        @if (numPages > 2) {
          <div class="row">
            <h6 i18n class="blue-label">
          <b>License Number:</b>
          <small class="blue-label">
            {{gearForm.get('licenseNumber')?.value}}
          </small>
          @if (gearForm.get('licenseNumber')?.errors?.required) {
<small
                  class="red-label">
            [Required]
          </small>
}
        </h6>
          </div>
        }
        @if (numPages > 2) {
          <div class="row">
            <h6 i18n class="blue-label">
          <b>Targeted Species:</b>
          <small class="blue-label">
            {{gearForm.get('targetSpecies')?.value}}
          </small>
          @if (gearForm.get('targetSpecies')?.errors?.required) {
<small
                  class="red-label">
            [Required]
          </small>
}
        </h6>
          </div>
        }
        @if (numPages > 2) {
          <div class="row">
            <h6 i18n class="blue-label">
          <b>Net Length:</b>
          <small class="blue-label">
            {{gearForm.get('netLength')?.value}}
          </small>
          @if (gearForm.get('netLength')?.errors?.required) {
<small class="red-label">
            [Required]
          </small>
}
        </h6>
          </div>
        }
        @if (numPages > 2) {
          <div class="row">
            <h6  class="blue-label">
              <b i18n>Rope Length:</b>
              <small i18n class="blue-label">
            {{gearForm.get('ropeLength')?.value}}
          </small>
              @if (gearForm.get('ropeLength')?.errors?.required) {
                <small i18n class="red-label">
            [Required]
          </small>
              }
            </h6>
          </div>
        }
        @if (numPages > 2) {
          <div class="row">
            <h6  class="blue-label">
              <b i18n>Number of Buoys:</b>
              <small i18n class="blue-label">
            {{gearForm.get('buoyNumber')?.value}}
          </small>
              @if (gearForm.get('buoyNumber')?.errors?.required) {
                <small i18n class="red-label">
            [Required]
          </small>
              }
            </h6>
          </div>
        }
        @if (numPages > 2 && gearForm.get('buoyNumber')?.value > 0) {
          <div class="row">
            <h6  class="blue-label">
              <b i18n>Buoy Description:</b>
              <small i18n class="blue-label">
            {{gearForm.get('buoyDescription')?.value}}
          </small>
              @if (gearForm.get('buoyDescription')?.errors?.required) {
                <small i18n class="red-label">
            [Required]
          </small>
              }
            </h6>
          </div>
        }
        @if (numPages == 6) {
          <div class="row">
            <h6  class="blue-label">
              <b i18n>Vessel Direction:</b>
              <small i18n class="blue-label">
            {{gearForm.get('vesselDirection')?.value}}
          </small>
            </h6>
          </div>
        }
        @if (numPages > 2) {
          <div class="row">
            <h6  class="blue-label">
              <b i18n>Latitude:</b>
              <small i18n class="blue-label">
            {{gearForm.get('latitude')?.value}}
          </small>
              @if (gearForm.get('latitude')?.hasError('object')) {
                <small i18n class="red-label">
            [Required]
          </small>
              }
            </h6>
          </div>
        }
        @if (numPages > 2) {
          <div class="row">
            <h6  class="blue-label">
              <b i18n>Longitude:</b>
              <small i18n class="blue-label">
            {{gearForm.get('longitude')?.value}}
          </small>
              @if (gearForm.get('longitude')?.hasError('object')) {
                <small i18n class="red-label">
            [Required]
          </small>
              }
            </h6>
          </div>
        }
        @if (numPages == 6) {
          <div class="row">
            <h6  class="blue-label">
              <b i18n>Management Area Fished:</b>
              <small i18n class="blue-label">
            {{gearForm.get('fisheryArea')?.value}}
          </small>
              @if (gearForm.get('fisheryArea')?.errors?.required) {
                <small i18n class="red-label">
            [Required]
          </small>
              }
            </h6>
          </div>
        }
        <div class="row">
          <h6 i18n class="blue-label">
          <b>
            Comments:
          </b>
          {{ gearForm.get('comments')?.value }}
        </h6>
        </div>
      </div>
    }


    <!-- Page navigation buttons -->
    @if (reportStatus != 'complete') {
      <div class="row bottom-buttons">
        <div class="col-1"></div>
        <div class="col-4">
          <div class="row">
            <button mat-raised-button
              class="fishing-button-blue"
              type="button"
              (click)="toPreviousPage()">
              <span i18n>
            Back
          </span>
            </button>
          </div>
        </div>
        <div class="col-2"></div>
        <div class="col-4">
          <div class="row">
            <button mat-raised-button
              class="fishing-button-red"
              type="submit"
              (click)="toNextPage()">
              @if (currPage <= numPages) {
                <span i18n>
            Next
          </span>
              }
              @if (currPage > numPages) {
                <span i18n>
            Submit
          </span>
              }
            </button>
          </div>
        </div>
        <div class="col-1"></div>
      </div>
    }

    @if (reportStatus === 'complete') {
      <div class="row bottom-buttons" style="display: flex; justify-content: center;">
        <div class="col-4">
          <div class="row" style="display: flex; justify-content: center;">
            <button mat-raised-button
              class="fishing-button-blue"
              type="button"
              (click)="toPreviousPage()">
              <span i18n>
            Back
          </span>
            </button>
          </div>
        </div>
      </div>
    }

  </div>
